<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                  'bg-gray-600': sharedService.userTheme === 'dark',
                  'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <h4 *ngIf="editMode == 'list'">Evaluator Codes </h4>
            <h4 *ngIf="editMode == 'edit'">{{evaluator.code}}</h4>
            <h4 *ngIf="editMode == 'add'">Add New Evaluator</h4>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list'" matTooltip="Add New" (click)="addEvaluator()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Save" (click)="saveEvaluator()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode == 'edit'" matTooltip="Delete" (click)="deleteEvaluator()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- List Mode -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="list.length !== 1">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4">
              <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{listFilter}}" />

              <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full" matSortActive="majorCat" matSortDirection="asc">
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
                  <td mat-cell *matCellDef="let spec">{{spec.code}}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                  <td mat-cell *matCellDef="let spec">{{spec.name}}</td>
                </ng-container>
                <ng-container matColumnDef="lastupdated">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
                  <td mat-cell *matCellDef="let spec">{{spec.lastupdated}}</td>
                </ng-container>
                <ng-container matColumnDef="updatedBy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
                  <td mat-cell *matCellDef="let spec">{{spec.updatedBy}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header disabled>Actions</th>
                  <td mat-cell *matCellDef="let spec">
                    <button mat-icon-button matTooltip="Edit" (click)="editEvaluator(spec)" [matTooltipShowDelay]="750">
                      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <!-- New / Edit Mode -->
  <form [formGroup]="evaluatorFormGroup">
    <div class="flex flex-col" *ngIf="editMode !== 'list'">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                  'bg-gray-600': sharedService.userTheme === 'dark',
                  'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap w-full sm:flex-col">
              <mat-card-content class="w-full">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field *ngIf="editMode =='add'">
                    <mat-label>Code</mat-label>
                    <input matInput formControlName="Code">
                    <mat-error *ngIf="evaluatorFormGroup.get('Code').invalid">
                      Required field / 10 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="Name">
                    <mat-error *ngIf="evaluatorFormGroup.get('Name').invalid">
                      Required field / 40 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="Address">
                    <mat-error *ngIf="evaluatorFormGroup.get('Address').invalid">
                      30 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>City</mat-label>
                    <input matInput formControlName="City">
                    <mat-error *ngIf="evaluatorFormGroup.get('City').invalid">
                      14 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>State</mat-label>
                    <input matInput formControlName="State">
                    <mat-error *ngIf="evaluatorFormGroup.get('State').invalid">
                      2 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Zip Code</mat-label>
                    <input matInput formControlName="Zip">
                    <mat-error *ngIf="evaluatorFormGroup.get('Zip').invalid">
                      9 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Program</mat-label>
                    <input matInput formControlName="Program">
                    <mat-error *ngIf="evaluatorFormGroup.get('Program').invalid">
                      40 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="Telephone">
                    <mat-error *ngIf="evaluatorFormGroup.get('Telephone').invalid">
                      10 Char Max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Fax</mat-label>
                    <input matInput formControlName="Fax">
                    <mat-error *ngIf="evaluatorFormGroup.get('Fax').invalid">
                      10 Char Max.
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
          </div>


        </div>
      </mat-card>

    </div>
  </form>
</div>
